"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMomentFormatToLuxon = exports.dateIsBefore = exports.dateIsAfter = exports.dateStrToDateTime = exports.fromYearWeekNumberDateToLuxon = exports.jsDateToFormat = exports.timestampToFormat = void 0;
var luxon_1 = require("luxon");
var constants_1 = require("./constants");
function timestampToFormat(timestamp, format) {
    try {
        return luxon_1.DateTime.fromMillis(timestamp).toFormat(constants_1.luxonDateFormatPerGroup[format] || constants_1.luxonDateFormatPerGroup.month);
    }
    catch (err) {
        return "".concat(timestamp);
    }
}
exports.timestampToFormat = timestampToFormat;
function jsDateToFormat(date, format) {
    return luxon_1.DateTime.fromJSDate(date).toFormat(constants_1.luxonDateFormatPerGroup[format] || constants_1.luxonDateFormatPerGroup.month);
}
exports.jsDateToFormat = jsDateToFormat;
/**
 * Required because DateTime.fromFormat(date, "'yyyy-'w'WW'") results in
 * an error.
 *
 * @param date A date formatted like `2023-w23`.
 * @returns The DateTime object corresponding to the given date.
 */
function fromYearWeekNumberDateToLuxon(date) {
    var _a = date.split('-w'), yearStr = _a[0], weekStr = _a[1];
    if (!yearStr || !weekStr) {
        console.error("Invalid date format \u2014 received ".concat(date, ", expects \"yyyy-'w'WW\""));
        return;
    }
    var week = parseInt(weekStr, 10);
    return luxon_1.DateTime.fromFormat(yearStr, 'yyyy').plus({ weeks: week });
}
exports.fromYearWeekNumberDateToLuxon = fromYearWeekNumberDateToLuxon;
/**
 * @param dateStr
 * @param dateUnit
 */
function dateStrToDateTime(dateStr, dateUnit) {
    if (dateUnit === constants_1.cDateUnit.week) {
        return fromYearWeekNumberDateToLuxon(dateStr);
    }
    return luxon_1.DateTime.fromFormat(dateStr, constants_1.luxonDateFormatPerGroup[dateUnit] || constants_1.luxonDateFormatPerGroup.month);
}
exports.dateStrToDateTime = dateStrToDateTime;
/**
 * Tests whether the first date provided is after the second date.
 *
 * Dates should be Luxon DateTime instances.
 * @param opts.date
 * @param opts.isAfter
 */
function dateIsAfter(opts) {
    // this does opts.date - opts.isAfter
    // It's positive if opts.date is after opts.isAfter
    return opts.date.diff(opts.isAfter).milliseconds > 0;
}
exports.dateIsAfter = dateIsAfter;
/**
 * Tests whether the first date provided is before the second date.
 *
 * Dates should be Luxon DateTime instances.
 * @param opts.date
 * @param opts.isBefore
 */
function dateIsBefore(opts) {
    // this does opts.isBefore - opts.date.
    // It's positive if opts.date is before opts.isBefore
    return opts.isBefore.diff(opts.date).milliseconds > 0;
}
exports.dateIsBefore = dateIsBefore;
/**
 * Converts a moment date format into a luxon one.
 * e.g. replaces 'YYYY' with 'yyyy', 'DD' with 'dd', etc.
 */
function convertMomentFormatToLuxon(date) {
    return date.replaceAll('YYYY', 'yyyy').replaceAll('DD', 'dd');
}
exports.convertMomentFormatToLuxon = convertMomentFormatToLuxon;
